export enum PriorityCodes {
    unkown = 0,
    stat = 1,
    routine = 2,
    maxPriority = 2,
    // labels = ['State', 'Routine'],
}

export enum RequestType {
    unkown = 0,
    mou = 1,
    adhoc = 2,
    // labels = ["MOU", "AdHoc"];
    maxRequestType = 2,
}

export enum RequestStatus {
    unknown = -1,
    closed = 0,
    open = 1,
    inReview = 2,
    accepted = 3,
    declined = 4,
    deleted = 5,
}

export enum Status {
    INFO = 0,
    ERROR = 1,
    SUCCESS = 2,
}

export enum wlmStates {
    Unknown= -1,
    Closed= 0,
    Open= 1,
    Pending= 2,
    Approved= 3,
    Declined= 4
}
export const tzMap: { [x: string]: string } = {
    Atlantic: 'America/Puerto_Rico',
    Eastern: 'America/New_York',
    Central: 'America/Chicago',
    Mountain: 'America/Denver',
    Arizona: 'America/Phoenix',
    Pacific: 'America/Los_Angeles',
    Hawaii: 'Pacific/Honolulu',
    Alaska: 'America/Anchorage',
    Pueruto_Rico: 'America/Puerto_Rico',
    Guam: 'Pacific/Guam',
    Manila: 'Asia/Manila',
    Philipines: 'Asia/Manila',
    Samoa: 'Pacific/Apia',
    Virgin_Islands: 'America/Port_of_Spain',
}

export const RequestedStatusName: any = {
    0: 'Unknown',
    1: 'Open',
    2: 'InReview',
    3: 'Accepted',
    4: 'Declined',
    5: 'Deleted',
}
